import React from "react";
import "./LegalPages.css";

const AcceptableUsePolicy = () => {
  return (
    <section className="legal-page">
      <h1>Acceptable Use Policy</h1>
      <p>
        This Acceptable Use Policy outlines the rules for using <b>Mailsnappy</b> responsibly.
        Violation of this policy may result in account suspension or termination.
      </p>

      <h2>1. Prohibited Content</h2>
      <p>
        You may not send or promote content that is illegal, offensive, harmful, or violates
        intellectual property rights.
      </p>

      <h2>2. Email Marketing Restrictions</h2>
      <p>
        You must only send emails to users who have given valid consent to receive messages from
        you. Purchased or rented email lists are strictly prohibited.
      </p>

      <h2>3. Security Practices</h2>
      <p>
        You must not attempt to gain unauthorized access to systems, servers, or data belonging to
        Mailsnappy or others.
      </p>

      <h2>4. Fair Usage</h2>
      <p>
        Excessive use of resources, attempts to disrupt our network, or abuse of the platform will
        lead to immediate suspension.
      </p>

      <h2>5. Reporting Abuse</h2>
      <p>
        If you suspect misuse or abuse of our platform, please report it to{" "}
        <a href="mailto:support@mailsnappy.com">support@mailsnappy.com</a>.
      </p>
    </section>
  );
};

export default AcceptableUsePolicy;
